import buttonDisabled from "../../../assets/sounds/effects/ButtonDisabled.mp3";
import { useSound } from "./useSound";

export const soundButtonDisabled = () => {
  const sound = useSound({src:buttonDisabled});

  sound.play();
};
